import { render, staticRenderFns } from "./Fktable.vue?vue&type=template&id=1e803222&scoped=true"
import script from "./Fktable.vue?vue&type=script&lang=js"
export * from "./Fktable.vue?vue&type=script&lang=js"
import style0 from "./Fktable.vue?vue&type=style&index=0&id=1e803222&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e803222",
  null
  
)

export default component.exports